<template>
  <div class="personal-activity">
    <Header />
    <div class="contents">
      <a href="https://www.mocumocu.com/" target="_blank">
        <div class="card">
          <div class="content">
            <img src="../assets/mocumocu.png" alt="" />
          </div>
          <h3>知識共有サイト mocumocu</h3>
          <div class="detail">
            <p>
              AWS
              の学習を始める際に、どうせだったらナレッジを共有できるようにしようと思い作成。サーバーレス構成。
            </p>
            <p class="stack">
              フロント: Vue.js, バック: Amplify, Lambda, API Gateway, DynamoDB,
              Python
            </p>
          </div>
        </div>
      </a>
      <a href="https://nuxt.materix.jp/" target="_blank">
        <div class="card">
          <div class="content">
            <img src="../assets/materix.png" alt="" />
          </div>
          <h3>数学・英語 Web 学習アプリ materix</h3>
          <div class="detail">
            <p>
              Web を活用した学習教材の可能性を探求したく作成。materix Lab
              のカリキュラムにも組み込んで使用し、検証が継続中。
            </p>
            <p class="stack">
              フロント: Nuxt.js, バック: Amplify, Lambda, API Gateway, DynamoDB,
              Python
            </p>
          </div>
        </div>
      </a>
      <a href="https://www.cuiz.jp/" target="_blank">
        <div class="card">
          <div class="content">
            <img src="../assets/cuiz.png" alt="" />
          </div>
          <h3>AWS 問題アプリ cuiz</h3>
          <div class="detail">
            <p>
              ちょっとでも楽しく知識のチェックができるよう、AWS
              の資格試験に関する問題をクイズ形式で解けるアプリ。サーバーレス構成。
            </p>
            <p class="stack">
              フロント: Vue.js, バック: Amplify, Lambda, API Gateway, GAS,
              Python
            </p>
          </div>
        </div>
      </a>
      <a href="https://lab.materix.jp/" target="_blank">
        <div class="card">
          <div class="content">
            <img src="../assets/materixlab.png" alt="" />
          </div>
          <h3>学習スペース materix Lab</h3>
          <div class="detail">
            <p>
              生徒の自主性を第一に考える学習スペース materix lab を運営。Web
              サイトや独自学習アプリの開発も担当する。
            </p>
            <p class="stack">
              フロント: Nuxt.js, バック: Amplify, Lambda, API Gateway, DynamoDB,
              Python, その他: AWS Backup
            </p>
          </div>
        </div>
      </a>
      <a
        href="https://www.amazon.co.jp/AWS%E3%82%A8%E3%83%B3%E3%82%B8%E3%83%8B%E3%82%A2%E5%85%A5%E9%96%80%E8%AC%9B%E5%BA%A7%E2%80%95%E2%80%95%E5%AD%A6%E7%BF%92%E3%83%AD%E3%83%BC%E3%83%89%E3%83%9E%E3%83%83%E3%83%97%E3%81%A7%E4%BD%93%E7%B3%BB%E7%9A%84%E3%81%AB%E5%AD%A6%E3%81%B6-CloudTech%E3%83%AD%E3%83%BC%E3%83%89%E3%83%9E%E3%83%83%E3%83%97%E4%BD%9C%E6%88%90%E5%A7%94%E5%93%A1%E4%BC%9A/dp/4297125374"
        target="_blank"
      >
        <div class="card">
          <div class="content">
            <img src="../assets/book.png" alt="" />
          </div>
          <h3>AWSエンジニア入門講座――学習ロードマップで体系的に学ぶ</h3>
          <div class="detail">
            <p>
              くろかわこうへいさん運営の初学者を導く AWS コミュニティ CloudTech
              のメンバーとして、一部執筆を担当。IAM の章を記述した。
            </p>
            <!-- <p class="stack">文章ｶｷｶｷ</p> -->
          </div>
        </div>
      </a>
    </div>
    <Footer />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default defineComponent({
  components: {
    Header,
    Footer,
  },
  setup() {
    //
  },
});
</script>

<style scoped>
* {
  color: #2c3e50;
}

img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

p {
  text-align: left;
}

a {
  text-decoration: none;
}

.contents {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 100px;
  margin: auto;
}

.card {
  width: 40vw;
  /* height: calc(40vw / 1.6); */
  box-shadow: 0px 0px 7px rgb(154, 154, 154);
  border-radius: 10px;
  background: white;
  cursor: pointer;
  transition-duration: 0.3s;
}

.card:hover {
  transform: translate(0, -5px);
  box-shadow: 3px 3px 0px rgb(60, 103, 255);
}

.card > h3 {
  margin: 10px 0;
}

.stack {
  text-align: center;
}

.detail {
  margin: 10px;
  padding: 0 20px 10px 20px;
}

.content {
  width: 40vw;
  height: 20vw;
}
</style>
